// src/scripts/contact/internal/api.js

import { getInstance, resetState } from './internal/state.js';
import { debugHelpers } from './internal/debugHelpers.js';
import { initializeContactSystem } from './internal/init.js';

export function getContactSystem() {
  return initializeContactSystem();
}

export function getContactSystemSync() {
  return getInstance();
}

export function withContactSystem(callback) {
  return initializeContactSystem().then(callback);
}

export function reinitializeContactSystem() {
  resetState();
  return initializeContactSystem();
}

export function debugContactSystem() {
  debugHelpers.enable();
}